import React from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '@learningblocks/exp-constants/lib/Icons/incorrect-relative';
import className from './style.module.scss';

export function CloseButton(props) {
  return (
    <span className={className.closeButton} onClick={props.closeToast}>
      <CloseIcon />
    </span>
  );
}

CloseButton.propTypes = {
  /**
   * closeToast [ injected by library]
   */
  closeToast: PropTypes.func,
};

CloseButton.defaultProps = {};
